module.exports = __webpack_public_path__ + "static/media/CarryOn_HandLaggage_Arrows_iOS12Fix.3a941b3f.usdz";